import { createContext, FC, ReactNode, useContext } from "react";

import { StudyType } from "@/types/resources";

interface StudyContextType {
  studyId: string | null;
  studyType: StudyType | null;
}

const StudyContext = createContext<StudyContextType>({
  studyId: null,
  studyType: null,
});

interface StudyProviderProps {
  children: ReactNode;
  studyId: string;
  studyType: StudyType | null;
}

export const StudyProvider: FC<StudyProviderProps> = ({
  children,
  studyId,
  studyType,
}) => {
  return (
    <StudyContext.Provider value={{ studyId, studyType }}>
      {children}
    </StudyContext.Provider>
  );
};

export const useStudyContext = (): StudyContextType => {
  return useContext(StudyContext);
};
